import React from 'react';
import styles from './PrizesTable.module.css';

const PrizesTable = ({ data, columns = [] }) => {
  return (
    <div className={styles.prizesTableContainer}>
      <table className={styles.prizesTable}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.name}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              {columns.map((column) => (
                <td key={column.name}>
                  {column.render ? column.render(row) : row[column.name]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PrizesTable;

